import PropTypes from "prop-types";
import borders from "assets/theme/base/borders";
import colors from "assets/theme/base/colors";
import rgba from "assets/theme/functions/rgba";
import { forwardRef } from "react";
import MKBox from "../../../components/MKBox";
import MKTypography from "../../../components/MKTypography";

const { black, white } = colors;
const { borderWidth, borderRadius } = borders;

const GridCard = forwardRef(({ children, title }, ref) => (
  <MKBox
    sx={{
      height: 1,
      wordWrap: "break-word",
      backgroundColor: white.main,
      backgroundClip: "border-box",
      border: `${borderWidth[1]} solid ${rgba(black.main, 0.25)}`,
      borderRadius: borderRadius.lg,
      boxShadow: "none",
      overflow: "visible",
    }}
    ref={ref}
  >
    {title ? (
      <MKBox
        sx={{
          m: 1,
          py: 0.5,
          backgroundColor: "secondary.main",
          borderBottom: `${borderWidth[1]} solid ${rgba(black.main, 0.125)}`,
          borderRadius: "none",
        }}
      >
        <MKTypography variant="h5" color="white" sx={{ textAlign: "center" }}>
          {title}
        </MKTypography>
      </MKBox>
    ) : null}

    <MKBox component="div" sx={{ overflow: "auto" }}>
      {children}
    </MKBox>
  </MKBox>
));

GridCard.defaultProps = {
  title: null,
};

GridCard.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default GridCard;
